import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  maxWidth: "880px",
  aspectRatio: "16 / 9",
  boxShadow: 24,
  outline: "none",
  backgroundColor: "transparent",
};

export default function VideoModal({ playVideo, setPlayVideo }) {
  return (
    <div>
      <Modal
        open={playVideo}
        onClose={() => setPlayVideo(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <iframe
            width="100%"
            height="100%"
            // src="https://www.youtube.com/embed/4SkRGCK6SyE?autoplay=1&controls=1&modestbranding=1"
            src="https://res.cloudinary.com/dgx3e75w9/video/upload/v1752939314/nxNearby_newest_video_rjgvce.mp4"
            title="video player"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            style={{
              borderRadius: "8px",
              backgroundColor: "#000",
            }}
          />
        </Box>
      </Modal>
    </div>
  );
}
